import { SkipLinkTargetsInput } from "@/components/SkipLinkTargetsInput";
import { SettingSwitch } from "./setting-switch";

interface SettingGroupProps {
  category: string;
  settings: Array<{
    key: string;
    label: string;
    description?: string;
    guideline?: string;
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
  }>;
  learnMoreUrl?: string;
  learnMoreText?: string;
  learnMoreLinkText?: string;
}

export const SettingGroup = ({ category, settings, learnMoreUrl, learnMoreText, learnMoreLinkText }: SettingGroupProps) => {

  return (
    <div className="cy:grid cy:grid-cols-20 cy:border cy:border-[#EAEBEC] cy:rounded-xs">
      {/* Left side - Category header */}
      <div className="cy:col-span-4 cy:bg-[#EAEBEC] cy:flex cy:items-center cy:justify-start cy:py-[10px] cy:px-4">
        <h3 className="cy:text-sm! cy:font-normal! cy:text-[#0251AF] cy:text-left!">
          {category}
        </h3>
      </div>
      
      {/* Right side - Settings */}
      <div className="cy:col-span-16 cy:bg-white cy:p-4 cy:space-y-[10px]">
        {settings.map((setting) => (
          <div key={setting.key}>
            <div className="cy:flex cy:items-center cy:justify-between">
              <div className="cy:flex-1 cy:pl-4">
                <SettingSwitch
                  checked={setting.checked}
                  onCheckedChange={setting.onCheckedChange}
                  label={setting.label}
                  description={setting.description}
                />
              </div>
              {setting.guideline && (
                <div className="cy:ml-4 cy:text-sm cy:text-[#73767F] cy:font-medium">
                  WCAG {setting.guideline}
                </div>
              )}
            </div>
            
            {/* Conditional input field for enableSkipLink */}
            {setting.key === "enableSkipLink.status" && setting.checked && (
              <SkipLinkTargetsInput
              />
            )}
          </div>
        ))}
        
        {/* Learn more link */}
        {learnMoreUrl && learnMoreText && learnMoreLinkText && (() => {
          const linkIndex = learnMoreText.indexOf(learnMoreLinkText);
          if (linkIndex === -1) {
            // If linkText not found, show full text as link
            return (
              <div className="cy:pl-4 cy:pt-[10px] cy:mt-2 cy:border-t cy:border-[#EAEBEC]">
                <a 
                  href={learnMoreUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="cy:text-sm cy:text-[#0251AF] cy:underline"
                >
                  {learnMoreText}
                </a>
              </div>
            );
          }
          
          const beforeLink = learnMoreText.substring(0, linkIndex);
          const afterLink = learnMoreText.substring(linkIndex + learnMoreLinkText.length);
          
          return (
            <div className="cy:pl-4 cy:pt-[10px] cy:mt-2 cy:border-t cy:border-[#EAEBEC] cy:text-sm">
              {beforeLink && <span className="cy:text-[#4E4B66]">{beforeLink}</span>}
              <a 
                href={learnMoreUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="cy:text-[#0251AF] cy:underline"
              >
                {learnMoreLinkText}
              </a>
              {afterLink && <span className="cy:text-[#4E4B66]">{afterLink}</span>}
            </div>
          );
        })()}
      </div>
    </div>
  );
};

